module.exports = __webpack_public_path__ + "static/kipa-sm-7d1e1f2314cda80404bf3ed733661a9a.jpg";